import React from 'react'
import CardGalerieVirtuelle from '../CardGalerieVirtuelle/CardGalerieVirtuelle'

const MapGalerieVirtuelle = (props) => {
    return ( props.TransferProps.length > 0 &&
        <>
            <div className="container-fluid">
                <div className="row justify-content-md-center">
                    {props.TransferProps.map(item => (
                        <CardGalerieVirtuelle className="col-md-4 col-xs-12 col-lg-4"
                            key={item.key}
                            NameArtist={item.NameArtist}
                            imgProfilRond={item.imgProfilRond} 
                            CategorieArtiste={item.CategorieArtiste} 
                            imgbg={item.imgbg} 
                            link={item.link} 
                            altimg={item.altimg}
                            linkToUnity={item.linkToUnity}
                            photoGV={item.photoGV}
                        />
                    ))}
                    
                </div>
                 
            </div>
               
        </>
    )
}

export default MapGalerieVirtuelle
